<template>
  <div :id="props.anchor || ''" class="kaer-component-wrap" :style="computedStyle" @click="$emit('handleClick')">
    <slot />
  </div>
</template>

<script>
import { px2rem } from '@/utils/utils';
import Fixed from '@/mixins/fixed';

export default {
  props: {
    props: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [Fixed],
  computed: {
    computedStyle() {
      const { props } = this;
      let style = {
        marginTop: px2rem(props.margin?.top),
        marginLeft: px2rem(props.margin?.left),
        marginRight: px2rem(props.margin?.right),
        marginBottom: px2rem(props.margin?.bottom),
        paddingTop: px2rem(props.padding?.top),
        paddingBottom: px2rem(props.padding?.bottom),
        paddingLeft: px2rem(props.padding?.left),
        paddingRight: px2rem(props.padding?.right),
        width: px2rem(props.width),
        height: px2rem(props.height),
      };
      if (props._layout === 'fixed') {
        style.position = 'fixed';
        Object.assign(style, this.positionContent);
      }
      return style;
    },
  },
  methods: {
    px2rem,
  },
};
</script>

<style scoped>
.kaer-component-wrap {
  /* width: 100%; */
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  /* margin: 20px; */
}
</style>
